// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { getData } from "../../../../Services/Fetchnodeservices";
// import OrderTrackingModal from "./OrderTrackingModal";

// // ─────────────────────────────────────────────────────────────────────────────
// // ICONS (optimized sizes)
// // ─────────────────────────────────────────────────────────────────────────────
// const EyeIcon = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
//     <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
//   </svg>
// );
// const SearchIcon = () => (
//   <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
//   </svg>
// );
// const ChevronLeftIcon = () => (
//   <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
//     <polyline points="15 18 9 12 15 6"/>
//   </svg>
// );
// const ChevronRightIcon = () => (
//   <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
//     <polyline points="9 18 15 12 9 6"/>
//   </svg>
// );
// const DetailsIcon = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
//     <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
//     <circle cx="12" cy="7" r="4"/>
//     <line x1="12" y1="11" x2="12" y2="15"/>
//     <line x1="10" y1="13" x2="14" y2="13"/>
//   </svg>
// );
// const TrackIcon = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
//     <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
//     <circle cx="12" cy="10" r="3"/>
//     <path d="M12 2v4M22 10h-4M2 10h4M12 18v4"/>
//   </svg>
// );
// const BackIcon = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <polyline points="15 18 9 12 15 6"/>
//   </svg>
// );

// // ─────────────────────────────────────────────────────────────────────────────
// // DATE FORMAT HELPER - dd/mm/yyyy
// // ─────────────────────────────────────────────────────────────────────────────
// const formatDate = (dateString) => {
//   if (!dateString) return "N/A";
//   const date = new Date(dateString);
//   if (isNaN(date.getTime())) return "N/A";
//   const day = String(date.getDate()).padStart(2, '0');
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const year = date.getFullYear();
//   return `${day}/${month}/${year}`;
// };

// const formatTime = (dateString) => {
//   if (!dateString) return "";
//   const date = new Date(dateString);
//   if (isNaN(date.getTime())) return "";
//   return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // SUB-COMPONENTS
// // ─────────────────────────────────────────────────────────────────────────────

// const StatusBadge = ({ status, isDark }) => {
//   const getConfig = () => {
//     switch(status?.toLowerCase()) {
//       case "completed": return { bg: isDark ? "rgba(34,197,94,0.15)" : "rgba(34,197,94,0.1)", color: "#22c55e", label: "Completed" };
//       case "pending": return { bg: isDark ? "rgba(245,158,11,0.15)" : "rgba(245,158,11,0.1)", color: "#f59e0b", label: "Pending" };
//       case "cancelled": return { bg: isDark ? "rgba(239,68,68,0.15)" : "rgba(239,68,68,0.1)", color: "#ef4444", label: "Cancelled" };
//       case "accepted": return { bg: isDark ? "rgba(59,130,246,0.15)" : "rgba(59,130,246,0.1)", color: "#3b82f6", label: "Accepted" };
//       case "preparing": return { bg: isDark ? "rgba(168,85,247,0.15)" : "rgba(168,85,247,0.1)", color: "#a855f7", label: "Preparing" };
//       case "ready": return { bg: isDark ? "rgba(236,72,153,0.15)" : "rgba(236,72,153,0.1)", color: "#ec4899", label: "Ready" };
//       case "out_for_delivery": return { bg: isDark ? "rgba(6,182,212,0.15)" : "rgba(6,182,212,0.1)", color: "#06b6d4", label: "Out for Delivery" };
//       case "delivered": return { bg: isDark ? "rgba(34,197,94,0.15)" : "rgba(34,197,94,0.1)", color: "#22c55e", label: "Delivered" };
//       case "dropped": return { bg: isDark ? "rgba(107,114,128,0.15)" : "rgba(107,114,128,0.1)", color: "#6b7280", label: "Dropped" };
//       default: return { bg: isDark ? "rgba(148,163,184,0.12)" : "rgba(148,163,184,0.08)", color: "#94a3b8", label: status || "Unknown" };
//     }
//   };
//   const c = getConfig();
//   return (
//     <span style={{
//       display: "inline-block", padding: "2px 8px", borderRadius: "16px",
//       fontSize: "9px", fontWeight: 600, background: c.bg, color: c.color,
//     }}>{c.label}</span>
//   );
// };

// const PayStatusBadge = ({ status, isDark }) => {
//   const config = {
//     paid: { bg: isDark ? "rgba(34,197,94,0.15)" : "rgba(34,197,94,0.1)", color: "#22c55e", label: "Paid" },
//     pending: { bg: isDark ? "rgba(245,158,11,0.15)" : "rgba(245,158,11,0.1)", color: "#f59e0b", label: "Pending" },
//   };
//   const c = config[status?.toLowerCase()] || config.pending;
//   return (
//     <span style={{
//       display: "inline-block", padding: "2px 8px", borderRadius: "16px",
//       fontSize: "9px", fontWeight: 600, background: c.bg, color: c.color,
//     }}>{c.label}</span>
//   );
// };

// const Checkbox = ({ checked, onChange, isDark }) => (
//   <div onClick={onChange} style={{
//     width: "14px", height: "14px", borderRadius: "3px",
//     border: checked ? "2px solid #3b82f6" : isDark ? "2px solid #3a4460" : "2px solid #cbd5e1",
//     background: checked ? "#3b82f6" : "transparent",
//     display: "flex", alignItems: "center", justifyContent: "center",
//     cursor: "pointer", transition: "all 0.15s ease",
//   }}>
//     {checked && (
//       <svg width="8" height="8" viewBox="0 0 12 12" fill="none">
//         <path d="M2 6l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
//       </svg>
//     )}
//   </div>
// );

// // ─────────────────────────────────────────────────────────────────────────────
// // MAIN COMPONENT - OrderTable
// // ─────────────────────────────────────────────────────────────────────────────
// const OrderTable = ({ isDark = true }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("All");
//   const [paymentFilter, setPaymentFilter] = useState("All");
//   const [selected, setSelected] = useState(new Set());
//   const [currentPage, setCurrentPage] = useState(1);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const itemsPerPage = 10;
//   const [quickFilter, setQuickFilter] = useState("all");
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [showTrackingModal, setShowTrackingModal] = useState(false);
//   const [isPreFiltered, setIsPreFiltered] = useState(false);
//   const [filterTitle, setFilterTitle] = useState("");

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     handleResize();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const isMobile = windowWidth <= 768;
//   const isTablet = windowWidth > 768 && windowWidth <= 1024;

//   const getOrderStatus = (order) => {
//     if (order.order_status_driver === "delivered") return "Delivered";
//     if (order.order_status_restro === "cancelled") return "Cancelled";
//     if (order.order_status_restro === "completed") return "Completed";
//     if (order.order_status_restro === "accepted") return "Active";
//     if (order.order_status_restro === "preparing") return "Preparing";
//     if (order.order_status_restro === "ready") return "Ready";
//     if (order.order_status_driver === "out_for_delivery") return "Out for Delivery";
//     if (order.order_status_driver === "picked") return "Picked";
//     return "New";
//   };

//   const fetchOrders = useCallback(async () => {
//     setLoading(true);
//     try {
//       // Check if we have pre-filtered data from navigation
//       const state = location.state;
//       if (state && state.data && state.data.length > 0) {
//         console.log("📦 Using pre-filtered order data from Dashboard:", state);
        
//         // Sort pre-filtered data in decreasing order (newest first)
//         const sortedData = [...state.data].sort((a, b) => {
//           return new Date(b.created_at) - new Date(a.created_at);
//         });
        
//         const transformedOrders = sortedData.map(order => ({
//           ...order,
//           orderId: `#${order.id}`,
//           status: getOrderStatus(order),
//           // ✅ Use organisation_name from backend as restaurant name
//           restaurant: order.organisation_name || order.designation || "Restaurant",
//           user: order.receiver_name || `User ${order.userid}`,
//           amount: order.final_amount || order.price,
//           date: formatDate(order.created_at),
//           time: formatTime(order.created_at)
//         }));
//         setOrders(transformedOrders);
//         setIsPreFiltered(true);
//         setFilterTitle(state.title || "Filtered Orders");
//         setLoading(false);
//         return;
//       }

//       // Otherwise fetch from API
//       const response = await getData("orders/Orders");
//       console.log(response, "response");
      
//       let ordersData = [];
//       if (Array.isArray(response)) ordersData = response;
//       else if (response?.data && Array.isArray(response.data)) ordersData = response.data;
//       else if (response?.orders && Array.isArray(response.orders)) ordersData = response.orders;
      
//       // ✅ SORT IN DECREASING ORDER (NEWEST FIRST)
//       ordersData = ordersData.sort((a, b) => {
//         return new Date(b.created_at) - new Date(a.created_at);
//       });
      
//       const transformedOrders = ordersData.map(order => ({
//         ...order,
//         orderId: `#${order.id}`,
//         status: getOrderStatus(order),
//         // ✅ Use organisation_name from backend as restaurant name
//         restaurant: order.organisation_name || order.designation || "Restaurant",
//         user: order.receiver_name || `User ${order.userid}`,
//         amount: order.final_amount || order.price,
//         date: formatDate(order.created_at),
//         time: formatTime(order.created_at)
//       }));
//       setOrders(transformedOrders);
//       setIsPreFiltered(false);
//       setFilterTitle("");
//     } catch (error) { 
//       console.error("Error fetching orders:", error); 
//     } finally { 
//       setLoading(false); 
//     }
//   }, [location.state]);

//   useEffect(() => { fetchOrders(); }, [fetchOrders]);

//   const matchesQuickFilter = (order) => {
//     switch (quickFilter) {
//       case "all": return true;
//       case "new": return order.order_status_restro === "pending" || !order.order_status_restro;
//       case "accepted_preparing_out": return ["accepted", "preparing", "ready", "out_for_delivery", "picked"].includes(order.order_status_restro) || order.order_status_driver === "out_for_delivery";
//       case "delivered": return order.order_status_driver === "delivered";
//       case "cancelled": return order.order_status_restro === "cancelled";
//       default: return true;
//     }
//   };

//   const filteredOrders = orders.filter(order => {
//     const matchesSearch = order.orderId.toLowerCase().includes(search.toLowerCase()) ||
//       order.restaurant?.toLowerCase().includes(search.toLowerCase()) ||
//       order.user?.toLowerCase().includes(search.toLowerCase()) ||
//       order.receiver_phone?.includes(search);
//     const matchesStatus = statusFilter === "All" || order.status === statusFilter;
//     const matchesPayment = paymentFilter === "All" || order.pay_method === paymentFilter;
//     const matchesQuick = matchesQuickFilter(order);
//     return matchesSearch && matchesStatus && matchesPayment && matchesQuick;
//   });

//   const totalFilteredCount = filteredOrders.length;
//   const totalPages = Math.ceil(totalFilteredCount / itemsPerPage);
//   const paginatedOrders = filteredOrders.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

//   const toggleAll = () => {
//     if (selected.size === paginatedOrders.length && paginatedOrders.length > 0) {
//       setSelected(new Set());
//     } else {
//       setSelected(new Set(paginatedOrders.map(o => o.id)));
//     }
//   };
  
//   const toggleOne = (id) => { 
//     const newSelected = new Set(selected); 
//     newSelected.has(id) ? newSelected.delete(id) : newSelected.add(id); 
//     setSelected(newSelected); 
//   };

//   const getQuickFilterCounts = () => ({
//     all: orders.length,
//     new: orders.filter(o => o.order_status_restro === "pending" || !o.order_status_restro).length,
//     accepted_preparing_out: orders.filter(o => ["accepted", "preparing", "ready", "out_for_delivery", "picked"].includes(o.order_status_restro) || o.order_status_driver === "out_for_delivery").length,
//     delivered: orders.filter(o => o.order_status_driver === "delivered").length,
//     cancelled: orders.filter(o => o.order_status_restro === "cancelled").length,
//   });
//   const counts = getQuickFilterCounts();

//   // ✅ Updated: View Full Details with restaurant name
//   const handleViewFullDetails = (order) => {
//     // Make sure restaurant name is passed with the order
//     const orderWithRestaurant = {
//       ...order,
//       restaurant: order.restaurant || order.organisation_name || order.designation || "Restaurant"
//     };
//     navigate("/Dashboard/OrderDetail", { state: { order: orderWithRestaurant } });
//   };
  


//    const handleViewFullDetails2 = (order) => {
//     const orderWithRestaurant = {
//       ...order,
//       restaurant: order.restaurant || order.organisation_name || order.designation || "Restaurant"
//     };
//     navigate("/Dashboard/OrderDetailPage2", { state: { order: orderWithRestaurant } });
//   };
  
//   const handleTrackOrder = (order) => { 
//     setSelectedOrder(order); 
//     setShowTrackingModal(true); 
//   };

//   const handleBack = () => {
//     navigate("/Dashboard");
//   };

//   // Function to go to last page
//   const goToLastPage = () => {
//     if (totalPages > 0) {
//       setCurrentPage(totalPages);
//     }
//   };

//   // Function to go to first page
//   const goToFirstPage = () => {
//     setCurrentPage(1);
//   };

//   const columnWidths = {
//     checkbox: "36px",
//     sn: "45px",
//     id: "70px",
//     status: "100px",
//     date: "120px",
//     restaurant: "140px",
//     user: "120px",
//     pay: "70px",
//     method: "75px",
//     restro: "90px",
//     driver: "90px",
//     amount: "80px",
//     actions: "80px"
//   };

//   const styles = {
//     container: { minHeight: "100vh", background: isDark ? "#0d1117" : "#f8fafc", fontFamily: "'Segoe UI', sans-serif", padding: isMobile ? "12px" : isTablet ? "16px 20px" : "20px 24px" },
//     contentWrapper: { maxWidth: "1600px", margin: "0 auto", width: "100%" },
//     header: { display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: "space-between", alignItems: isMobile ? "stretch" : "center", marginBottom: "16px", gap: isMobile ? "12px" : "16px" },
//     titleSection: { flex: isMobile ? "auto" : 1, display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" },
//     title: { fontSize: isMobile ? "18px" : "20px", fontWeight: 700, color: isDark ? "#f1f5f9" : "#0f172a", margin: 0 },
//     subtitle: { fontSize: "11px", color: "#64748b", marginTop: "2px" },
//     backBtn: { display: "flex", alignItems: "center", gap: "6px", padding: "6px 14px", borderRadius: "8px", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", background: "transparent", color: isDark ? "#94a3b8" : "#64748b", cursor: "pointer", fontSize: "12px", transition: "all 0.2s" },
//     filterBadge: { display: "inline-flex", alignItems: "center", gap: "6px", padding: "4px 12px", borderRadius: "20px", fontSize: "11px", fontWeight: 600, background: isDark ? "rgba(59,130,246,0.15)" : "rgba(59,130,246,0.1)", color: "#3b82f6", border: isDark ? "1px solid rgba(59,130,246,0.2)" : "1px solid rgba(59,130,246,0.15)" },
//     searchWrapper: { position: "relative", width: isMobile ? "100%" : isTablet ? "250px" : "300px", flexShrink: 0 },
//     searchIcon: { position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#3b82f6" },
//     searchInput: { width: "100%", padding: "8px 12px 8px 36px", background: isDark ? "#141824" : "#ffffff", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "10px", fontSize: "12px", color: isDark ? "#f1f5f9" : "#1e293b", outline: "none", boxSizing: "border-box" },
//     quickActionsRow: { display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "16px", padding: "10px 14px", background: isDark ? "#141824" : "#ffffff", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "12px" },
//     quickActionBtn: (isActive, type) => ({ display: "flex", alignItems: "center", gap: "6px", padding: "6px 12px", borderRadius: "30px", fontSize: "11px", fontWeight: 600, cursor: "pointer", border: "none", background: isActive ? type === "new" ? "#3b82f6" : type === "accepted_preparing_out" ? "#f59e0b" : type === "delivered" ? "#22c55e" : type === "cancelled" ? "#ef4444" : isDark ? "#1e3a8a" : "#e2e8f0" : isDark ? "rgba(255,255,255,0.05)" : "#f1f5f9", color: isActive ? "#ffffff" : isDark ? "#94a3b8" : "#475569" }),
//     quickBtnCount: { background: "rgba(0,0,0,0.2)", padding: "2px 6px", borderRadius: "16px", fontSize: "9px", fontWeight: 600 },
//     filtersRow: { display: "flex", flexWrap: "wrap", gap: "12px", marginBottom: "16px", paddingBottom: "10px", borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0" },
//     filterGroup: { display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap", backgroundColor: isDark ? "rgba(0,0,0,0.2)" : "rgba(0,0,0,0.02)", padding: "4px 10px", borderRadius: "10px" },
//     filterLabel: { fontSize: "10px", fontWeight: 700, color: "#64748b", textTransform: "uppercase" },
//     filterBtn: (isActive) => ({ padding: "3px 8px", borderRadius: "14px", fontSize: "10px", fontWeight: 500, background: isActive ? "#3b82f6" : isDark ? "transparent" : "#f1f5f9", color: isActive ? "#fff" : isDark ? "#94a3b8" : "#475569", border: isActive ? "1px solid #3b82f6" : isDark ? "1px solid #2a3145" : "1px solid #e2e8f0", cursor: "pointer" }),
//     selectionBar: { display: "flex", alignItems: "center", gap: "10px", background: isDark ? "rgba(59,130,246,0.08)" : "rgba(59,130,246,0.04)", border: isDark ? "1px solid rgba(59,130,246,0.2)" : "1px solid rgba(59,130,246,0.15)", borderRadius: "8px", padding: "6px 12px", marginBottom: "12px", flexWrap: "wrap" },
//     tableCard: { background: isDark ? "#141824" : "#ffffff", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "12px", overflow: "hidden" },
//     tableWrapper: { overflowX: "auto", WebkitOverflowScrolling: "touch" },
//     table: { width: "100%", borderCollapse: "collapse", tableLayout: "fixed", minWidth: "1100px" },
//     th: (width) => ({ padding: "12px 8px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: "#3b82f6", borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", background: isDark ? "#0f1520" : "#f8fafc", whiteSpace: "nowrap", width: width || "auto" }),
//     td: { padding: "10px 8px", fontSize: "11px", color: isDark ? "#e2e8f0" : "#1e293b", borderBottom: isDark ? "1px solid #1a2035" : "1px solid #f1f5f9", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
//     pagination: { display: "flex", flexDirection: isMobile ? "column" : "row", alignItems: "center", justifyContent: "space-between", gap: isMobile ? "10px" : "0", padding: "12px 16px", borderTop: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", background: isDark ? "#0f1520" : "#f8fafc" },
//     paginationInfo: { fontSize: "11px", color: "#64748b" },
//     paginationButtons: { display: "flex", gap: "4px", flexWrap: "wrap" },
//     pageBtn: (disabled, isActive) => ({ width: "28px", height: "28px", borderRadius: "6px", border: isActive ? "1px solid #3b82f6" : isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", background: isActive ? "#1e3a8a" : isDark ? "#141824" : "#ffffff", color: isActive ? "#93c5fd" : disabled ? isDark ? "#2d3a55" : "#cbd5e1" : isDark ? "#94a3b8" : "#64748b", cursor: disabled ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px" }),
//     scrollHint: { display: isMobile ? "flex" : "none", alignItems: "center", justifyContent: "center", marginBottom: "8px", padding: "4px 10px", fontSize: "9px", color: "#3b82f6", backgroundColor: isDark ? "rgba(59,130,246,0.1)" : "rgba(59,130,246,0.06)", borderRadius: "16px", width: "fit-content", margin: "0 auto 8px auto", gap: "4px" },
//     loadingContainer: { display: "flex", justifyContent: "center", alignItems: "center", padding: "50px", color: "#64748b", fontSize: "12px", flexDirection: "column", gap: "12px" },
//     actionButton: { background: "none", border: "none", cursor: "pointer", padding: "6px", borderRadius: "6px", display: "inline-flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s", color: isDark ? "#94a3b8" : "#64748b" },
//     actionButtonsWrapper: { display: "flex", gap: "8px", alignItems: "center" },
//   };

//   // Custom spinner for loading
//   const Spinner = () => (
//     <div style={{ width: "30px", height: "30px", border: `3px solid ${isDark ? "#1e2740" : "#e2e8f0"}`, borderTopColor: "#3b82f6", borderRadius: "50%", animation: "spin 1s linear infinite" }} />
//   );

//   if (loading) {
//     return (
//       <div style={styles.container}>
//         <div style={styles.loadingContainer}>
//           <Spinner />
//           <span>Loading orders...</span>
//         </div>
//         <style>{`
//           @keyframes spin { to { transform: rotate(360deg); } }
//         `}</style>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.container}>
//       <div style={styles.contentWrapper}>
//         <style>{`
//           .custom-scroll::-webkit-scrollbar { height: 4px; }
//           .custom-scroll::-webkit-scrollbar-track { background: ${isDark ? "#1a2035" : "#e2e8f0"}; border-radius: 10px; }
//           .custom-scroll::-webkit-scrollbar-thumb { background: #3b82f6; border-radius: 10px; }
//           button:hover { opacity: 0.85; }
//           [data-tooltip] { position: relative; cursor: pointer; }
//           [data-tooltip]:before {
//             content: attr(data-tooltip);
//             position: absolute;
//             bottom: 100%;
//             left: 50%;
//             transform: translateX(-50%);
//             padding: 4px 8px;
//             background: #1e293b;
//             color: #fff;
//             font-size: 10px;
//             font-weight: 500;
//             white-space: nowrap;
//             border-radius: 6px;
//             display: none;
//             z-index: 100;
//             margin-bottom: 8px;
//             pointer-events: none;
//           }
//           [data-tooltip]:hover:before { display: block; }
//           @keyframes spin { to { transform: rotate(360deg); } }
//         `}</style>

//         <div style={styles.header}>
//           <div style={styles.titleSection}>
//             <button onClick={handleBack} style={styles.backBtn}>
//               <BackIcon /> Back
//             </button>
//             <div>
//               <h1 style={styles.title}>
//                 {isPreFiltered ? filterTitle : "All Orders"}
//               </h1>
//               <p style={styles.subtitle}>
//                 {isPreFiltered 
//                   ? `Showing ${orders.length} ${filterTitle.toLowerCase()}`
//                   : "Manage and track all customer orders"}
//               </p>
//             </div>
//             {isPreFiltered && (
//               <span style={styles.filterBadge}>
//                 <span>📋</span> {orders.length} orders
//               </span>
//             )}
//           </div>
//           <div style={styles.searchWrapper}>
//             <span style={styles.searchIcon}><SearchIcon /></span>
//             <input 
//               type="text" 
//               style={styles.searchInput} 
//               placeholder="Search by order ID, restaurant, customer..." 
//               value={search} 
//               onChange={(e) => setSearch(e.target.value)} 
//             />
//           </div>
//         </div>

//         {!isPreFiltered && (
//           <div style={styles.quickActionsRow}>
//             <button style={styles.quickActionBtn(quickFilter === "all", "all")} onClick={() => { setQuickFilter("all"); setCurrentPage(1); }}>📋 All <span style={styles.quickBtnCount}>{counts.all}</span></button>
//             <button style={styles.quickActionBtn(quickFilter === "new", "new")} onClick={() => { setQuickFilter("new"); setCurrentPage(1); }}>🆕 New <span style={styles.quickBtnCount}>{counts.new}</span></button>
//             <button style={styles.quickActionBtn(quickFilter === "accepted_preparing_out", "accepted_preparing_out")} onClick={() => { setQuickFilter("accepted_preparing_out"); setCurrentPage(1); }}>🍳 Active <span style={styles.quickBtnCount}>{counts.accepted_preparing_out}</span></button>
//             <button style={styles.quickActionBtn(quickFilter === "delivered", "delivered")} onClick={() => { setQuickFilter("delivered"); setCurrentPage(1); }}>✅ Delivered <span style={styles.quickBtnCount}>{counts.delivered}</span></button>
//             <button style={styles.quickActionBtn(quickFilter === "cancelled", "cancelled")} onClick={() => { setQuickFilter("cancelled"); setCurrentPage(1); }}>❌ Cancelled <span style={styles.quickBtnCount}>{counts.cancelled}</span></button>
//           </div>
//         )}

//         <div style={styles.filtersRow}>
//           <div style={styles.filterGroup}>
//             <span style={styles.filterLabel}>Status:</span>
//             <div style={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
//               {["All", "New", "Active", "Delivered", "Cancelled", "Preparing", "Ready", "Out for Delivery"].map(s => (
//                 <button key={s} style={styles.filterBtn(statusFilter === s)} onClick={() => { setStatusFilter(s); setCurrentPage(1); }}>{s}</button>
//               ))}
//             </div>
//           </div>
//           <div style={styles.filterGroup}>
//             <span style={styles.filterLabel}>Payment:</span>
//             <div style={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
//               {["All", "COD", "Online"].map(p => (
//                 <button key={p} style={styles.filterBtn(paymentFilter === p)} onClick={() => { setPaymentFilter(p); setCurrentPage(1); }}>{p}</button>
//               ))}
//             </div>
//           </div>
//         </div>

//         {selected.size > 0 && (
//           <div style={styles.selectionBar}>
//             <span style={{ fontSize: "11px", color: "#93c5fd", fontWeight: 600 }}>✓ {selected.size} order{selected.size > 1 ? "s" : ""} selected</span>
//             <div style={{ flex: 1 }} />
//             <button onClick={() => setSelected(new Set())} style={{ padding: "4px 10px", borderRadius: "6px", border: "1px solid #3b4460", background: "#1e2740", color: "#94a3b8", fontSize: "10px", cursor: "pointer" }}>Clear</button>
//           </div>
//         )}

//         {isMobile && filteredOrders.length > 0 && (
//           <div style={styles.scrollHint}>
//             <span>👉</span> Swipe horizontally to see all columns <span>👈</span>
//           </div>
//         )}

//         <div style={styles.tableCard}>
//           <div style={styles.tableWrapper} className="custom-scroll">
//             <table style={styles.table}>
//               <thead>
//                 <tr style={{ background: isDark ? "#0f1520" : "#f8fafc" }}>
//                   <th style={styles.th(columnWidths.checkbox)}>
//                     <Checkbox 
//                       checked={selected.size === paginatedOrders.length && paginatedOrders.length > 0} 
//                       onChange={toggleAll} 
//                       isDark={isDark} 
//                     />
//                   </th>
//                   <th style={styles.th(columnWidths.sn)}>#</th>
//                   <th style={styles.th(columnWidths.id)}>Order ID</th>
//                   <th style={styles.th(columnWidths.status)}>Status</th>
//                   <th style={styles.th(columnWidths.date)}>Date & Time</th>
//                   <th style={styles.th(columnWidths.restaurant)}>Restaurant</th>
//                   <th style={styles.th(columnWidths.user)}>Customer</th>
//                   <th style={styles.th(columnWidths.pay)}>Payment</th>
//                   <th style={styles.th(columnWidths.method)}>Method</th>
//                   <th style={styles.th(columnWidths.restro)}>Restro</th>
//                   <th style={styles.th(columnWidths.driver)}>Driver</th>
//                   <th style={styles.th(columnWidths.amount)}>Amount</th>
//                   <th style={styles.th(columnWidths.actions)}>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {paginatedOrders.length === 0 ? (
//                   <tr>
//                     <td colSpan="13" style={{ padding: "60px", textAlign: "center", color: "#64748b", fontSize: "13px" }}>
//                       🍽️ No orders found
//                     </td>
//                   </tr>
//                 ) : (
//                   paginatedOrders.map((order, idx) => {
//                     // ✅ SN IN DECREASING ORDER
//                     const sn = totalFilteredCount - ((currentPage - 1) * itemsPerPage + idx);
//                     return (
//                       <tr 
//                         key={order.id} 
//                         style={{ 
//                           background: selected.has(order.id) 
//                             ? (isDark ? "rgba(59,130,246,0.07)" : "rgba(59,130,246,0.03)") 
//                             : "transparent",
//                           transition: "background 0.2s"
//                         }}
//                       >
//                         <td style={styles.td}>
//                           <Checkbox 
//                             checked={selected.has(order.id)} 
//                             onChange={() => toggleOne(order.id)} 
//                             isDark={isDark} 
//                           />
//                         </td>
//                         <td style={styles.td}>{sn}</td>
//                         <td style={styles.td}>
//                           <span style={{ fontFamily: "monospace", fontWeight: 600, color: "#3b82f6", fontSize: "11px" }}>
//                             {order.orderId}
//                           </span>
//                         </td>
//                         <td style={styles.td}>
//                           <StatusBadge status={order.status} isDark={isDark} />
//                         </td>
//                         <td style={styles.td}>
//                           <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
//                             <span>{order.date}</span>
//                             <span style={{ fontSize: "9px", color: "#64748b" }}>
//                               {order.time}
//                             </span>
//                           </div>
//                         </td>
//                         {/* ✅ Restaurant Name with organisation_name */}
//                         <td style={styles.td}>
//                           <span 
//                             title={order.restaurant}
//                             style={{
//                               fontWeight: 500,
//                               color: isDark ? "#e2e8f0" : "#1e293b"
//                             }}
//                           >
//                             {order.restaurant?.length > 15 ? order.restaurant.substring(0, 12) + "..." : order.restaurant}
//                           </span>
//                         </td>
//                         <td style={styles.td}>
//                           <span title={order.user}>
//                             {order.user?.length > 12 ? order.user.substring(0, 10) + "..." : order.user}
//                           </span>
//                         </td>
//                         <td style={styles.td}>
//                           <PayStatusBadge status={order.pay_status} isDark={isDark} />
//                         </td>
//                         <td style={styles.td}>
//                           <span style={{ fontSize: "10px", fontWeight: 500 }}>{order.pay_method || "COD"}</span>
//                         </td>
//                         <td style={styles.td}>
//                           <StatusBadge status={order.order_status_restro} isDark={isDark} />
//                         </td>
//                         <td style={styles.td}>
//                           <StatusBadge status={order.order_status_driver} isDark={isDark} />
//                         </td>
//                         <td style={styles.td}>
//                           <span style={{ fontWeight: 600, color: "#10b981", fontSize: "11px" }}>
//                             ₹{order.amount}
//                           </span>
//                         </td>
//                         <td style={styles.td}>
//                           <div style={styles.actionButtonsWrapper}>
//                             <button 
//                               data-tooltip="Order Details" 
//                               onClick={() => handleViewFullDetails(order)} 
//                               style={styles.actionButton}
//                             >
//                               <DetailsIcon />
//                             </button>
//                             <button 
//                               data-tooltip="Track Order" 
//                               onClick={() => handleTrackOrder(order)} 
//                               style={styles.actionButton}
//                             >
//                               <TrackIcon />
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {filteredOrders.length > 0 && totalPages > 1 && (
//             <div style={styles.pagination}>
//               <div style={styles.paginationInfo}>
//                 Showing {Math.min((currentPage - 1) * itemsPerPage + 1, filteredOrders.length)} - {Math.min(currentPage * itemsPerPage, filteredOrders.length)} of {filteredOrders.length} orders
//               </div>
//               <div style={styles.paginationButtons}>
//                 <button 
//                   onClick={goToFirstPage} 
//                   disabled={currentPage === 1} 
//                   style={styles.pageBtn(currentPage === 1, false)}
//                   title="First Page"
//                 >
//                   ««
//                 </button>
                
//                 <button 
//                   onClick={() => setCurrentPage(p => Math.max(1, p - 1))} 
//                   disabled={currentPage === 1} 
//                   style={styles.pageBtn(currentPage === 1, false)}
//                 >
//                   <ChevronLeftIcon />
//                 </button>
                
//                 {(() => {
//                   const pages = [];
//                   const maxVisible = isMobile ? 3 : 5;
//                   let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
//                   let endPage = Math.min(totalPages, startPage + maxVisible - 1);
                  
//                   if (endPage - startPage + 1 < maxVisible) {
//                     startPage = Math.max(1, endPage - maxVisible + 1);
//                   }
                  
//                   for (let i = startPage; i <= endPage; i++) {
//                     pages.push(
//                       <button 
//                         key={i} 
//                         onClick={() => setCurrentPage(i)} 
//                         style={styles.pageBtn(false, currentPage === i)}
//                       >
//                         {i}
//                       </button>
//                     );
//                   }
//                   return pages;
//                 })()}
                
//                 <button 
//                   onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} 
//                   disabled={currentPage === totalPages} 
//                   style={styles.pageBtn(currentPage === totalPages, false)}
//                 >
//                   <ChevronRightIcon />
//                 </button>
                
//                 <button 
//                   onClick={goToLastPage} 
//                   disabled={currentPage === totalPages} 
//                   style={styles.pageBtn(currentPage === totalPages, false)}
//                   title="Last Page"
//                 >
//                   »»
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {showTrackingModal && selectedOrder && (
//         <OrderTrackingModal 
//           order={selectedOrder} 
//           onClose={() => setShowTrackingModal(false)} 
//           isDark={isDark} 
//         />
//       )}
//     </div>
//   );
// };

// export default OrderTable;

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getData } from "../../../../Services/Fetchnodeservices";
import OrderTrackingModal from "./OrderTrackingModal";

// ─────────────────────────────────────────────────────────────────────────────
// ICONS (optimized sizes)
// ─────────────────────────────────────────────────────────────────────────────
const EyeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
  </svg>
);
const SearchIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
);
const ChevronLeftIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <polyline points="15 18 9 12 15 6"/>
  </svg>
);
const ChevronRightIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <polyline points="9 18 15 12 9 6"/>
  </svg>
);
const DetailsIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
    <line x1="12" y1="11" x2="12" y2="15"/>
    <line x1="10" y1="13" x2="14" y2="13"/>
  </svg>
);
const TrackIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
    <path d="M12 2v4M22 10h-4M2 10h4M12 18v4"/>
  </svg>
);
const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);
const BackIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="15 18 9 12 15 6"/>
  </svg>
);

// ─────────────────────────────────────────────────────────────────────────────
// DATE FORMAT HELPER - dd/mm/yyyy
// ─────────────────────────────────────────────────────────────────────────────
const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "N/A";
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const formatTime = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

// ─────────────────────────────────────────────────────────────────────────────
// SUB-COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────

const StatusBadge = ({ status, isDark }) => {
  const getConfig = () => {
    switch(status?.toLowerCase()) {
      case "completed": return { bg: isDark ? "rgba(34,197,94,0.15)" : "rgba(34,197,94,0.1)", color: "#22c55e", label: "Completed" };
      case "pending": return { bg: isDark ? "rgba(245,158,11,0.15)" : "rgba(245,158,11,0.1)", color: "#f59e0b", label: "Pending" };
      case "cancelled": return { bg: isDark ? "rgba(239,68,68,0.15)" : "rgba(239,68,68,0.1)", color: "#ef4444", label: "Cancelled" };
      case "accepted": return { bg: isDark ? "rgba(59,130,246,0.15)" : "rgba(59,130,246,0.1)", color: "#3b82f6", label: "Accepted" };
      case "preparing": return { bg: isDark ? "rgba(168,85,247,0.15)" : "rgba(168,85,247,0.1)", color: "#a855f7", label: "Preparing" };
      case "ready": return { bg: isDark ? "rgba(236,72,153,0.15)" : "rgba(236,72,153,0.1)", color: "#ec4899", label: "Ready" };
      case "out_for_delivery": return { bg: isDark ? "rgba(6,182,212,0.15)" : "rgba(6,182,212,0.1)", color: "#06b6d4", label: "Out for Delivery" };
      case "delivered": return { bg: isDark ? "rgba(34,197,94,0.15)" : "rgba(34,197,94,0.1)", color: "#22c55e", label: "Delivered" };
      case "dropped": return { bg: isDark ? "rgba(107,114,128,0.15)" : "rgba(107,114,128,0.1)", color: "#6b7280", label: "Dropped" };
      default: return { bg: isDark ? "rgba(148,163,184,0.12)" : "rgba(148,163,184,0.08)", color: "#94a3b8", label: status || "Unknown" };
    }
  };
  const c = getConfig();
  return (
    <span style={{
      display: "inline-block", padding: "2px 8px", borderRadius: "16px",
      fontSize: "9px", fontWeight: 600, background: c.bg, color: c.color,
    }}>{c.label}</span>
  );
};

const PayStatusBadge = ({ status, isDark }) => {
  const config = {
    paid: { bg: isDark ? "rgba(34,197,94,0.15)" : "rgba(34,197,94,0.1)", color: "#22c55e", label: "Paid" },
    pending: { bg: isDark ? "rgba(245,158,11,0.15)" : "rgba(245,158,11,0.1)", color: "#f59e0b", label: "Pending" },
  };
  const c = config[status?.toLowerCase()] || config.pending;
  return (
    <span style={{
      display: "inline-block", padding: "2px 8px", borderRadius: "16px",
      fontSize: "9px", fontWeight: 600, background: c.bg, color: c.color,
    }}>{c.label}</span>
  );
};

const Checkbox = ({ checked, onChange, isDark }) => (
  <div onClick={onChange} style={{
    width: "14px", height: "14px", borderRadius: "3px",
    border: checked ? "2px solid #3b82f6" : isDark ? "2px solid #3a4460" : "2px solid #cbd5e1",
    background: checked ? "#3b82f6" : "transparent",
    display: "flex", alignItems: "center", justifyContent: "center",
    cursor: "pointer", transition: "all 0.15s ease",
  }}>
    {checked && (
      <svg width="8" height="8" viewBox="0 0 12 12" fill="none">
        <path d="M2 6l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    )}
  </div>
);

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT - OrderTable
// ─────────────────────────────────────────────────────────────────────────────
const OrderTable = ({ isDark = true }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [paymentFilter, setPaymentFilter] = useState("All");
  const [selected, setSelected] = useState(new Set());
  const [currentPage, setCurrentPage] = useState(1);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const itemsPerPage = 10;
  const [quickFilter, setQuickFilter] = useState("all");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showTrackingModal, setShowTrackingModal] = useState(false);
  const [isPreFiltered, setIsPreFiltered] = useState(false);
  const [filterTitle, setFilterTitle] = useState("");

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  const getOrderStatus = (order) => {
    if (order.order_status_driver === "delivered") return "Delivered";
    if (order.order_status_restro === "cancelled") return "Cancelled";
    if (order.order_status_restro === "completed") return "Completed";
    if (order.order_status_restro === "accepted") return "Active";
    if (order.order_status_restro === "preparing") return "Preparing";
    if (order.order_status_restro === "ready") return "Ready";
    if (order.order_status_driver === "out_for_delivery") return "Out for Delivery";
    if (order.order_status_driver === "picked") return "Picked";
    return "New";
  };

  const fetchOrders = useCallback(async () => {
    setLoading(true);
    try {
      const state = location.state;
      if (state && state.data && state.data.length > 0) {
        const sortedData = [...state.data].sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        
        const transformedOrders = sortedData.map(order => ({
          ...order,
          orderId: `#${order.id}`,
          status: getOrderStatus(order),
          restaurant: order.organisation_name || order.designation || "Restaurant",
          user: order.receiver_name || `User ${order.userid}`,
          amount: order.final_amount || order.price,
          date: formatDate(order.created_at),
          time: formatTime(order.created_at)
        }));
        setOrders(transformedOrders);
        setIsPreFiltered(true);
        setFilterTitle(state.title || "Filtered Orders");
        setLoading(false);
        return;
      }

      const response = await getData("orders/Orders");
      console.log(response,"responce");
      
      
      let ordersData = [];
      if (Array.isArray(response)) ordersData = response;
      else if (response?.data && Array.isArray(response.data)) ordersData = response.data;
      else if (response?.orders && Array.isArray(response.orders)) ordersData = response.orders;
      
      ordersData = ordersData.sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      });
      
      const transformedOrders = ordersData.map(order => ({
        ...order,
        orderId: `#${order.id}`,
        status: getOrderStatus(order),
        restaurant: order.organisation_name || order.designation || "Restaurant",
        user: order.receiver_name || `User ${order.userid}`,
        amount: order.final_amount || order.price,
        date: formatDate(order.created_at),
        time: formatTime(order.created_at)
      }));
      setOrders(transformedOrders);
      setIsPreFiltered(false);
      setFilterTitle("");
    } catch (error) { 
      console.error("Error fetching orders:", error); 
    } finally { 
      setLoading(false); 
    }
  }, [location.state]);

  useEffect(() => { fetchOrders(); }, [fetchOrders]);

  const matchesQuickFilter = (order) => {
    switch (quickFilter) {
      case "all": return true;
      case "new": return order.order_status_restro === "pending" || !order.order_status_restro;
      case "accepted_preparing_out": return ["accepted", "preparing", "ready", "out_for_delivery", "picked"].includes(order.order_status_restro) || order.order_status_driver === "out_for_delivery";
      case "delivered": return order.order_status_driver === "delivered";
      case "cancelled": return order.order_status_restro === "cancelled";
      default: return true;
    }
  };

  const filteredOrders = orders.filter(order => {
    const matchesSearch = order.orderId.toLowerCase().includes(search.toLowerCase()) ||
      order.restaurant?.toLowerCase().includes(search.toLowerCase()) ||
      order.user?.toLowerCase().includes(search.toLowerCase()) ||
      order.receiver_phone?.includes(search);
    const matchesStatus = statusFilter === "All" || order.status === statusFilter;
    const matchesPayment = paymentFilter === "All" || order.pay_method === paymentFilter;
    const matchesQuick = matchesQuickFilter(order);
    return matchesSearch && matchesStatus && matchesPayment && matchesQuick;
  });

  const totalFilteredCount = filteredOrders.length;
  const totalPages = Math.ceil(totalFilteredCount / itemsPerPage);
  const paginatedOrders = filteredOrders.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const toggleAll = () => {
    if (selected.size === paginatedOrders.length && paginatedOrders.length > 0) {
      setSelected(new Set());
    } else {
      setSelected(new Set(paginatedOrders.map(o => o.id)));
    }
  };
  
  const toggleOne = (id) => { 
    const newSelected = new Set(selected); 
    newSelected.has(id) ? newSelected.delete(id) : newSelected.add(id); 
    setSelected(newSelected); 
  };

  const getQuickFilterCounts = () => ({
    all: orders.length,
    new: orders.filter(o => o.order_status_restro === "pending" || !o.order_status_restro).length,
    accepted_preparing_out: orders.filter(o => ["accepted", "preparing", "ready", "out_for_delivery", "picked"].includes(o.order_status_restro) || o.order_status_driver === "out_for_delivery").length,
    delivered: orders.filter(o => o.order_status_driver === "delivered").length,
    cancelled: orders.filter(o => o.order_status_restro === "cancelled").length,
  });
  const counts = getQuickFilterCounts();

  const handleViewFullDetails = (order) => {
    const orderWithRestaurant = {
      ...order,
      restaurant: order.restaurant || order.organisation_name || order.designation || "Restaurant"
    };
    navigate("/Dashboard/OrderDetail", { state: { order: orderWithRestaurant } });
  };

  const handleViewFullDetails2 = (order) => {
    const orderWithRestaurant = {
      ...order,
      restaurant: order.restaurant || order.organisation_name || order.designation || "Restaurant"
    };
    navigate("/Dashboard/OrderDetailPage2", { state: { order: orderWithRestaurant } });
  };
  
  const handleTrackOrder = (order) => { 
    setSelectedOrder(order); 
    setShowTrackingModal(true); 
  };

  const handleEditOrder = (order) => {
    navigate("/Dashboard/EditOrder", { state: { order } });
  };

  const handleBack = () => {
    navigate("/Dashboard");
  };

  const goToLastPage = () => {
    if (totalPages > 0) {
      setCurrentPage(totalPages);
    }
  };

  const goToFirstPage = () => {
    setCurrentPage(1);
  };

  const styles = {
    container: { minHeight: "100vh", background: isDark ? "#0d1117" : "#f8fafc", fontFamily: "'Segoe UI', sans-serif", padding: isMobile ? "12px" : isTablet ? "16px 20px" : "20px 24px" },
    contentWrapper: { maxWidth: "1600px", margin: "0 auto", width: "100%" },
    header: { display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: "space-between", alignItems: isMobile ? "stretch" : "center", marginBottom: "16px", gap: isMobile ? "12px" : "16px" },
    titleSection: { flex: isMobile ? "auto" : 1, display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" },
    title: { fontSize: isMobile ? "18px" : "20px", fontWeight: 700, color: isDark ? "#f1f5f9" : "#0f172a", margin: 0 },
    subtitle: { fontSize: "11px", color: "#64748b", marginTop: "2px" },
    backBtn: { display: "flex", alignItems: "center", gap: "6px", padding: "6px 14px", borderRadius: "8px", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", background: "transparent", color: isDark ? "#94a3b8" : "#64748b", cursor: "pointer", fontSize: "12px", transition: "all 0.2s" },
    filterBadge: { display: "inline-flex", alignItems: "center", gap: "6px", padding: "4px 12px", borderRadius: "20px", fontSize: "11px", fontWeight: 600, background: isDark ? "rgba(59,130,246,0.15)" : "rgba(59,130,246,0.1)", color: "#3b82f6", border: isDark ? "1px solid rgba(59,130,246,0.2)" : "1px solid rgba(59,130,246,0.15)" },
    searchWrapper: { position: "relative", width: isMobile ? "100%" : isTablet ? "250px" : "300px", flexShrink: 0 },
    searchIcon: { position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#3b82f6" },
    searchInput: { width: "100%", padding: "8px 12px 8px 36px", background: isDark ? "#141824" : "#ffffff", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "10px", fontSize: "12px", color: isDark ? "#f1f5f9" : "#1e293b", outline: "none", boxSizing: "border-box" },
    quickActionsRow: { display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "16px", padding: "10px 14px", background: isDark ? "#141824" : "#ffffff", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "12px" },
    quickActionBtn: (isActive, type) => ({ display: "flex", alignItems: "center", gap: "6px", padding: "6px 12px", borderRadius: "30px", fontSize: "11px", fontWeight: 600, cursor: "pointer", border: "none", background: isActive ? type === "new" ? "#3b82f6" : type === "accepted_preparing_out" ? "#f59e0b" : type === "delivered" ? "#22c55e" : type === "cancelled" ? "#ef4444" : isDark ? "#1e3a8a" : "#e2e8f0" : isDark ? "rgba(255,255,255,0.05)" : "#f1f5f9", color: isActive ? "#ffffff" : isDark ? "#94a3b8" : "#475569" }),
    quickBtnCount: { background: "rgba(0,0,0,0.2)", padding: "2px 6px", borderRadius: "16px", fontSize: "9px", fontWeight: 600 },
    filtersRow: { display: "flex", flexWrap: "wrap", gap: "12px", marginBottom: "16px", paddingBottom: "10px", borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0" },
    filterGroup: { display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap", backgroundColor: isDark ? "rgba(0,0,0,0.2)" : "rgba(0,0,0,0.02)", padding: "4px 10px", borderRadius: "10px" },
    filterLabel: { fontSize: "10px", fontWeight: 700, color: "#64748b", textTransform: "uppercase" },
    filterBtn: (isActive) => ({ padding: "3px 8px", borderRadius: "14px", fontSize: "10px", fontWeight: 500, background: isActive ? "#3b82f6" : isDark ? "transparent" : "#f1f5f9", color: isActive ? "#fff" : isDark ? "#94a3b8" : "#475569", border: isActive ? "1px solid #3b82f6" : isDark ? "1px solid #2a3145" : "1px solid #e2e8f0", cursor: "pointer" }),
    selectionBar: { display: "flex", alignItems: "center", gap: "10px", background: isDark ? "rgba(59,130,246,0.08)" : "rgba(59,130,246,0.04)", border: isDark ? "1px solid rgba(59,130,246,0.2)" : "1px solid rgba(59,130,246,0.15)", borderRadius: "8px", padding: "6px 12px", marginBottom: "12px", flexWrap: "wrap" },
    tableCard: { background: isDark ? "#141824" : "#ffffff", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "12px", overflow: "hidden" },
    table: { width: "100%", borderCollapse: "collapse" },
    th: { padding: "12px 8px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: "#3b82f6", borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", background: isDark ? "#0f1520" : "#f8fafc", whiteSpace: "nowrap" },
    td: { padding: "10px 8px", fontSize: "11px", color: isDark ? "#e2e8f0" : "#1e293b", borderBottom: isDark ? "1px solid #1a2035" : "1px solid #f1f5f9", wordBreak: "break-word" },
    pagination: { display: "flex", flexDirection: isMobile ? "column" : "row", alignItems: "center", justifyContent: "space-between", gap: isMobile ? "10px" : "0", padding: "12px 16px", borderTop: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", background: isDark ? "#0f1520" : "#f8fafc" },
    paginationInfo: { fontSize: "11px", color: "#64748b" },
    paginationButtons: { display: "flex", gap: "4px", flexWrap: "wrap" },
    pageBtn: (disabled, isActive) => ({ width: "28px", height: "28px", borderRadius: "6px", border: isActive ? "1px solid #3b82f6" : isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", background: isActive ? "#1e3a8a" : isDark ? "#141824" : "#ffffff", color: isActive ? "#93c5fd" : disabled ? isDark ? "#2d3a55" : "#cbd5e1" : isDark ? "#94a3b8" : "#64748b", cursor: disabled ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px" }),
    loadingContainer: { display: "flex", justifyContent: "center", alignItems: "center", padding: "50px", color: "#64748b", fontSize: "12px", flexDirection: "column", gap: "12px" },
    actionButton: { background: "none", border: "none", cursor: "pointer", padding: "6px", borderRadius: "6px", display: "inline-flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s", color: isDark ? "#94a3b8" : "#64748b" },
    actionButtonsWrapper: { display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" },
  };

  const Spinner = () => (
    <div style={{ width: "30px", height: "30px", border: `3px solid ${isDark ? "#1e2740" : "#e2e8f0"}`, borderTopColor: "#3b82f6", borderRadius: "50%", animation: "spin 1s linear infinite" }} />
  );

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loadingContainer}>
          <Spinner />
          <span>Loading orders...</span>
        </div>
        <style>{`
          @keyframes spin { to { transform: rotate(360deg); } }
        `}</style>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.contentWrapper}>
        <style>{`
          button:hover { opacity: 0.85; }
          [data-tooltip] { position: relative; cursor: pointer; }
          [data-tooltip]:before {
            content: attr(data-tooltip);
            position: absolute;
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%);
            padding: 4px 8px;
            background: #1e293b;
            color: #fff;
            font-size: 10px;
            font-weight: 500;
            white-space: nowrap;
            border-radius: 6px;
            display: none;
            z-index: 100;
            margin-bottom: 8px;
            pointer-events: none;
          }
          [data-tooltip]:hover:before { display: block; }
          @keyframes spin { to { transform: rotate(360deg); } }
        `}</style>

        <div style={styles.header}>
          <div style={styles.titleSection}>
            <button onClick={handleBack} style={styles.backBtn}>
              <BackIcon /> Back
            </button>
            <div>
              <h1 style={styles.title}>
                {isPreFiltered ? filterTitle : "All Orders"}
              </h1>
              <p style={styles.subtitle}>
                {isPreFiltered 
                  ? `Showing ${orders.length} ${filterTitle.toLowerCase()}`
                  : "Manage and track all customer orders"}
              </p>
            </div>
            {isPreFiltered && (
              <span style={styles.filterBadge}>
                <span>📋</span> {orders.length} orders
              </span>
            )}
          </div>
          <div style={styles.searchWrapper}>
            <span style={styles.searchIcon}><SearchIcon /></span>
            <input 
              type="text" 
              style={styles.searchInput} 
              placeholder="Search by order ID, restaurant, customer..." 
              value={search} 
              onChange={(e) => setSearch(e.target.value)} 
            />
          </div>
        </div>

        {!isPreFiltered && (
          <div style={styles.quickActionsRow}>
            <button style={styles.quickActionBtn(quickFilter === "all", "all")} onClick={() => { setQuickFilter("all"); setCurrentPage(1); }}>📋 All <span style={styles.quickBtnCount}>{counts.all}</span></button>
            <button style={styles.quickActionBtn(quickFilter === "new", "new")} onClick={() => { setQuickFilter("new"); setCurrentPage(1); }}>🆕 New <span style={styles.quickBtnCount}>{counts.new}</span></button>
            <button style={styles.quickActionBtn(quickFilter === "accepted_preparing_out", "accepted_preparing_out")} onClick={() => { setQuickFilter("accepted_preparing_out"); setCurrentPage(1); }}>🍳 Active <span style={styles.quickBtnCount}>{counts.accepted_preparing_out}</span></button>
            <button style={styles.quickActionBtn(quickFilter === "delivered", "delivered")} onClick={() => { setQuickFilter("delivered"); setCurrentPage(1); }}>✅ Delivered <span style={styles.quickBtnCount}>{counts.delivered}</span></button>
            <button style={styles.quickActionBtn(quickFilter === "cancelled", "cancelled")} onClick={() => { setQuickFilter("cancelled"); setCurrentPage(1); }}>❌ Cancelled <span style={styles.quickBtnCount}>{counts.cancelled}</span></button>
          </div>
        )}

        <div style={styles.filtersRow}>
          <div style={styles.filterGroup}>
            <span style={styles.filterLabel}>Status:</span>
            <div style={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
              {["All", "New", "Active", "Delivered", "Cancelled", "Preparing", "Ready", "Out for Delivery"].map(s => (
                <button key={s} style={styles.filterBtn(statusFilter === s)} onClick={() => { setStatusFilter(s); setCurrentPage(1); }}>{s}</button>
              ))}
            </div>
          </div>
          <div style={styles.filterGroup}>
            <span style={styles.filterLabel}>Payment:</span>
            <div style={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
              {["All", "COD", "Online"].map(p => (
                <button key={p} style={styles.filterBtn(paymentFilter === p)} onClick={() => { setPaymentFilter(p); setCurrentPage(1); }}>{p}</button>
              ))}
            </div>
          </div>
        </div>

        {selected.size > 0 && (
          <div style={styles.selectionBar}>
            <span style={{ fontSize: "11px", color: "#93c5fd", fontWeight: 600 }}>✓ {selected.size} order{selected.size > 1 ? "s" : ""} selected</span>
            <div style={{ flex: 1 }} />
            <button onClick={() => setSelected(new Set())} style={{ padding: "4px 10px", borderRadius: "6px", border: "1px solid #3b4460", background: "#1e2740", color: "#94a3b8", fontSize: "10px", cursor: "pointer" }}>Clear</button>
          </div>
        )}

        <div style={styles.tableCard}>
          <table style={styles.table}>
            <thead>
              <tr style={{ background: isDark ? "#0f1520" : "#f8fafc" }}>
                <th style={styles.th}>
                  <Checkbox 
                    checked={selected.size === paginatedOrders.length && paginatedOrders.length > 0} 
                    onChange={toggleAll} 
                    isDark={isDark} 
                  />
                </th>
                <th style={styles.th}>#</th>
                <th style={styles.th}>Order ID</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Date & Time</th>
                <th style={styles.th}>Restaurant</th>
                <th style={styles.th}>Customer</th>
                <th style={styles.th}>Payment</th>
                <th style={styles.th}>Method</th>
                <th style={styles.th}>Restro</th>
                <th style={styles.th}>Driver</th>
                <th style={styles.th}>Amount</th>
                <th style={styles.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedOrders.length === 0 ? (
                <tr>
                  <td colSpan="13" style={{ padding: "60px", textAlign: "center", color: "#64748b", fontSize: "13px" }}>
                    🍽️ No orders found
                  </td>
                </tr>
              ) : (
                paginatedOrders.map((order, idx) => {
                  const sn = totalFilteredCount - ((currentPage - 1) * itemsPerPage + idx);
                  return (
                    <tr 
                      key={order.id} 
                      style={{ 
                        background: selected.has(order.id) 
                          ? (isDark ? "rgba(59,130,246,0.07)" : "rgba(59,130,246,0.03)") 
                          : "transparent",
                        transition: "background 0.2s"
                      }}
                    >
                      <td style={styles.td}>
                        <Checkbox 
                          checked={selected.has(order.id)} 
                          onChange={() => toggleOne(order.id)} 
                          isDark={isDark} 
                        />
                      </td>
                      <td style={styles.td}>{sn}</td>
                      <td style={styles.td}>
                        <span style={{ fontFamily: "monospace", fontWeight: 600, color: "#3b82f6", fontSize: "11px" }}>
                          {order.orderId}
                        </span>
                      </td>
                      <td style={styles.td}>
                        <StatusBadge status={order.status} isDark={isDark} />
                      </td>
                      <td style={styles.td}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                          <span>{order.date}</span>
                          <span style={{ fontSize: "9px", color: "#64748b" }}>
                            {order.time}
                          </span>
                        </div>
                      </td>
                      <td style={styles.td}>
                        <span style={{ fontWeight: 500, color: isDark ? "#e2e8f0" : "#1e293b" }}>
                          {order.restaurant}
                        </span>
                      </td>
                      <td style={styles.td}>
                        <span>{order.user}</span>
                      </td>
                      <td style={styles.td}>
                        <PayStatusBadge status={order.pay_status} isDark={isDark} />
                      </td>
                      <td style={styles.td}>
                        <span style={{ fontSize: "10px", fontWeight: 500 }}>{order.pay_method || "COD"}</span>
                      </td>
                      <td style={styles.td}>
                        <StatusBadge status={order.order_status_restro} isDark={isDark} />
                      </td>
                      <td style={styles.td}>
                        <StatusBadge status={order.order_status_driver} isDark={isDark} />
                      </td>
                      <td style={styles.td}>
                        <span style={{ fontWeight: 600, color: "#10b981", fontSize: "11px" }}>
                          ₹{order.amount}
                        </span>
                      </td>
                      <td style={styles.td}>
                        <div style={styles.actionButtonsWrapper}>
                          <button 
                            data-tooltip="Order Details" 
                            onClick={() => handleViewFullDetails(order)} 
                            style={styles.actionButton}
                          >
                            <DetailsIcon />
                          </button>
                          <button 
                            data-tooltip="Track Order" 
                            onClick={() => handleTrackOrder(order)} 
                            style={styles.actionButton}
                          >
                            <TrackIcon />
                          </button>
                          <button 
                            data-tooltip="Edit Order" 
                            onClick={() => handleViewFullDetails2(order)} 
                            style={styles.actionButton}
                          >
                            <EditIcon />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>

          {filteredOrders.length > 0 && totalPages > 1 && (
            <div style={styles.pagination}>
              <div style={styles.paginationInfo}>
                Showing {Math.min((currentPage - 1) * itemsPerPage + 1, filteredOrders.length)} - {Math.min(currentPage * itemsPerPage, filteredOrders.length)} of {filteredOrders.length} orders
              </div>
              <div style={styles.paginationButtons}>
                <button 
                  onClick={goToFirstPage} 
                  disabled={currentPage === 1} 
                  style={styles.pageBtn(currentPage === 1, false)}
                  title="First Page"
                >
                  ««
                </button>
                
                <button 
                  onClick={() => setCurrentPage(p => Math.max(1, p - 1))} 
                  disabled={currentPage === 1} 
                  style={styles.pageBtn(currentPage === 1, false)}
                >
                  <ChevronLeftIcon />
                </button>
                
                {(() => {
                  const pages = [];
                  const maxVisible = isMobile ? 3 : 5;
                  let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
                  let endPage = Math.min(totalPages, startPage + maxVisible - 1);
                  
                  if (endPage - startPage + 1 < maxVisible) {
                    startPage = Math.max(1, endPage - maxVisible + 1);
                  }
                  
                  for (let i = startPage; i <= endPage; i++) {
                    pages.push(
                      <button 
                        key={i} 
                        onClick={() => setCurrentPage(i)} 
                        style={styles.pageBtn(false, currentPage === i)}
                      >
                        {i}
                      </button>
                    );
                  }
                  return pages;
                })()}
                
                <button 
                  onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} 
                  disabled={currentPage === totalPages} 
                  style={styles.pageBtn(currentPage === totalPages, false)}
                >
                  <ChevronRightIcon />
                </button>
                
                <button 
                  onClick={goToLastPage} 
                  disabled={currentPage === totalPages} 
                  style={styles.pageBtn(currentPage === totalPages, false)}
                  title="Last Page"
                >
                  »»
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {showTrackingModal && selectedOrder && (
        <OrderTrackingModal 
          order={selectedOrder} 
          onClose={() => setShowTrackingModal(false)} 
          isDark={isDark} 
        />
      )}
    </div>
  );
};

export default OrderTable;